var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('TopHeader',{on:{"openRespMenu":_vm.openRespMenu}}),_c('MainSearch'),_c('RespLoginModal'),_c('CartLists'),_c('RespMenu',{ref:"respMenu"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }